import { cn } from '@/lib/utils';

interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
  verticalSpacing?: 'none' | 'sm' | 'md' | 'lg';
}

export function PageContainer({ 
  children, 
  className,
  verticalSpacing = 'md'
}: PageContainerProps) {
  const spacingClasses = {
    none: '',
    sm: 'py-4',
    md: 'py-8',
    lg: 'py-12',
  };

  return (
    <div
      className={cn(
        'mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8',
        spacingClasses[verticalSpacing],
        className
      )}
    >
      {children}
    </div>
  );
}

